(function () {
  'use strict';

  function initFaqList(list) {
    if (list._morliFaqInit) return;
    list._morliFaqInit = true;

    list.querySelectorAll('[data-faq-item]').forEach(function (item) {
      var toggle = item.querySelector('[data-faq-toggle]');
      var body = item.querySelector('[data-faq-body]');
      if (!toggle || !body) return;

      toggle.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        list.querySelectorAll('[data-faq-item].is-open').forEach(function (openItem) {
          openItem.classList.remove('is-open');
          openItem.querySelector('[data-faq-toggle]').setAttribute('aria-expanded', 'false');
          openItem.querySelector('[data-faq-body]').hidden = true;
        });

        if (!isOpen) {
          item.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          body.hidden = false;
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-faq-list]').forEach(initFaqList);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-faq-list]').forEach(initFaqList);
  });
})();
